"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _6Y44Y5UFcjs = require('../__chunks/6Y44Y5UF.cjs');


var _SZWBUSP4cjs = require('../__chunks/SZWBUSP4.cjs');
require('../__chunks/NKGUWTUC.cjs');
require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/O7FALLU5.cjs');
require('../__chunks/WU47XUXM.cjs');
require('../__chunks/OJZKTJL7.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/tooltip/tooltip-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function TooltipProvider(props = {}) {
  const store = _6Y44Y5UFcjs.useTooltipStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _SZWBUSP4cjs.TooltipContextProvider, { value: store, children: props.children });
}


exports.TooltipProvider = TooltipProvider;
